import objectPath from "object-path";
import config from "@/common/config/layout.config.json";
import menuConfigJson from "@/common/config/menu.config.json";

// action types
export const SET_LAYOUT_CONFIG = "setLayoutConfig";
export const OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig";

// mutation types

export default {
  state: {
    config: config,
    menu_config:menuConfigJson
  },
  getters: {
    /**
     * Get config from layout config
     * @param state
     * @returns {function(path, defaultValue): *}
     */
    layoutConfig: state => (path, defaultValue) => {
      return objectPath.get(state.config, path, defaultValue);
    },
    menuConfig(state){
      return state.menu_config
    }
  },
  actions: {
    [SET_LAYOUT_CONFIG](state, payload) {
      state.commit(SET_LAYOUT_CONFIG, payload);
    },
    [OVERRIDE_LAYOUT_CONFIG](state) {
      state.commit(OVERRIDE_LAYOUT_CONFIG);
    }
  },
  mutations: {
    activeMenuConfig(state) {
      state.menu_config.active = true;
    },
    [SET_LAYOUT_CONFIG](state, payload) {
      state.config = payload;
    },
    [OVERRIDE_LAYOUT_CONFIG](state) {
      state.config = Object.assign(
        {},
        state.config,
        JSON.parse(localStorage.getItem("config"))
      );
    }
  }
};
